<template>
    <!-- component -->
<div class="font-sans">
    <div class="backdrop bg-opacity-10">
    <div class="relative min-h-screen flex flex-col sm:justify-center items-center" >
        <div class="relative sm:max-w-sm w-full" >
            <div class="card bg-blue-400 shadow-lg  w-full h-full rounded-3xl absolute  transform -rotate-6"></div>
            <div class="card bg-green-400 shadow-lg  w-full h-full rounded-3xl absolute  transform rotate-6"></div>
            <div class="relative w-full rounded-3xl  px-6 py-4 bg-gray-100 shadow-md">
                <div class="text-h6 text-overline">{{t('login.pleasesignin')}}</div>
                <div class="q-gutter-sm">
               <q-input v-model="emailToken" type="email">{{t('login.email')}}</q-input>
               <q-input v-model="passwordToken" type="password">{{t('login.password')}}</q-input>
                <q-checkbox v-model="stayLoggedIn" >{{t('login.remember')}}</q-checkbox>
                <q-space></q-space>
                <q-btn class="full-width" color="positive" @click="validateCredentials">{{t('login.submit')}}</q-btn>
                <q-btn class="full-width" color="primary" to="/register">{{t('login.register')}}</q-btn>        
                </div>

            </div>
        </div>
    </div>
    </div>
</div>
</template>

<script>
import firebase from "firebase";
import { useI18n } from "vue-i18n";


export default {
  setup() {
    const { t } = useI18n({
      inheritLocale: true,
      useScope: "local",
    });
    return {t}},
    data() {
        return {
            stayLoggedIn: false,
            passwordToken: '',
            emailToken: '',
        }
    },
    methods: {
        validateCredentials() {
        firebase
              .auth()
              .signInWithEmailAndPassword(this.emailToken, this.passwordToken)
              .then(() => {
                this.$router.replace({ name: "Dashboard" });
              })
              .catch(err => {
                this.error = err.message;
              });
        }
    }
}
</script>

<style lang="scss">
/* width */
::-webkit-scrollbar {
  width: 2px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}
.font-sans {
    background-image: url("../../assets/forest.jpg");
  background-repeat: no-repeat;
  background-size: cover;
}
.backdrop {
      backdrop-filter: blur(15px);
    }
</style>